import { z } from 'zod';

export const Timeframe = z.enum(['thisWeek', 'thisMonth', 'previousWeek', 'previousMonth']);

export type Timeframe = z.infer<typeof Timeframe>;

export const DEFAULT_TIMEFRAME: Timeframe = 'thisWeek';
